import Box from "@mui/material/Box";
import logo from "../images/logo/alogo.svg";
import { tokens } from "../styles/tokens";

/**
 * Shown while auth resolves. Stays dark — the logo asset is white-on-transparent.
 */
export default function Splash() {
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: tokens.color.ink,
        animation: "artome-splash-fade 300ms ease-in",
        "@keyframes artome-splash-fade": {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },
      }}
    >
      <Box component="img" src={logo} alt="Artome" sx={{ width: 200 }} />
    </Box>
  );
}
